module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousAir
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Air Freight Import Tracking")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.mainPageModal.airImportSeries),
      callback: function($$v) {
        _vm.$set(_vm.mainPageModal, "airImportSeries", $$v)
      },
      expression: "mainPageModal.airImportSeries"
    }
  })], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffAirMultiBlId"
    }
  }, [_vm._v("HAWBL No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "ffAirMultiBlId",
      "option-text": "secondBLNumber",
      "list": _vm.HAWBLNoList,
      "placeholder": "Select HAWBL No."
    },
    model: {
      value: (_vm.docModal.ffAirMultiBlId),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "ffAirMultiBlId", $$v)
      },
      expression: "docModal.ffAirMultiBlId"
    }
  }), _vm._v(" "), (!_vm.docModal.ffAirMultiBlId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.ffAirMultiBlId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "trackingDoc"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "trackingDocVal",
      "option-text": "trackingDocText",
      "list": _vm.trackingDocList,
      "placeholder": "Select Document "
    },
    model: {
      value: (_vm.docModal.trackingDoc),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "trackingDoc", $$v)
      },
      expression: "docModal.trackingDoc"
    }
  }), _vm._v(" "), (!_vm.docModal.trackingDoc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.trackingDoc))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Document")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "trackDocUpload",
      "id": "trackDocUpload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangetracking
    },
    model: {
      value: (_vm.docModal.trackDocUpload),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "trackDocUpload", $$v)
      },
      expression: "docModal.trackDocUpload"
    }
  })], 1), _vm._v(" "), (!_vm.docModal.trackDocUpload) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.trackDocUpload))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Receiving Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "receivingDate",
      "name": "receivingDate"
    },
    model: {
      value: (_vm.docModal.receivingDate),
      callback: function($$v) {
        _vm.$set(_vm.docModal, "receivingDate", $$v)
      },
      expression: "docModal.receivingDate"
    }
  }), _vm._v(" "), (!_vm.docModal.receivingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.receivingDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.uploadMultipleDoc
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.docTableData.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Document Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("HAWBL No.")]), _vm._v(" "), _c('th', [_vm._v("Document")]), _vm._v(" "), _c('th', [_vm._v("Receiving Date")]), _vm._v(" "), _c('th', [_vm._v("View Doc")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.docTableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.HAWBLNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.trackingDoc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.receivingDate)))]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewDoc(item.trackDocUpload)
        }
      }
    }, [_c('md-icon', [_vm._v("visibility")])], 1)], 1)
  }))])])]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [((_vm.mainPageModal.containerInfo == 'Consolidation' || (_vm.mainPageModal.PODLocationId == _vm.mainPageModal.finalPlaceLocationId))) ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Date of Arrival(Airport)")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "arivalDatePort",
      "name": "arivalDatePort"
    },
    model: {
      value: (_vm.BookingShippingLine.arivalDatePort),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "arivalDatePort", $$v)
      },
      expression: "BookingShippingLine.arivalDatePort"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.mainPageModal.containerInfo == 'Normal' && (_vm.mainPageModal.PODLocationId != _vm.mainPageModal.finalPlaceLocationId))) ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Date of Delivery(At Door)")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "deliveryDateDoor",
      "name": "deliveryDateDoor"
    },
    model: {
      value: (_vm.BookingShippingLine.deliveryDateDoor),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "deliveryDateDoor", $$v)
      },
      expression: "BookingShippingLine.deliveryDateDoor"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.multiHAWBL), function(item, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "labelMargtop",
      attrs: {
        "gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "30"
      }
    }, [_c('label', [_vm._v("HAWBL No.")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "value": item.secondBLNumber,
        "disabled": ""
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), (_vm.mainPageModal.containerInfo == 'Consolidation') ? _c('md-layout', {
      attrs: {
        "md-flex": "30"
      }
    }, [_c('label', [_vm._v("Delivery Mode")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "value": item.houseDeliveryMode == 'upto_AirPort' ? 'Upto AirPort' : item.houseDeliveryMode,
        "disabled": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), (_vm.mainPageModal.containerInfo == 'Consolidation') ? _c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [_c('label', [_vm._v("Final Delivery Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "HAWBDate",
        "name": "HAWBDate"
      },
      model: {
        value: (_vm.finalCargoDeliveryDate[index]),
        callback: function($$v) {
          _vm.$set(_vm.finalCargoDeliveryDate, index, $$v)
        },
        expression: "finalCargoDeliveryDate[index]"
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.mainPageModal.containerInfo != 'Consolidation') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Actual Date of Arrival(Airport)")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualDatePort",
      "name": "actualDatePort"
    },
    model: {
      value: (_vm.BookingShippingLine.actualDatePort),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "actualDatePort", $$v)
      },
      expression: "BookingShippingLine.actualDatePort"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addTrack
    }
  }, [_vm._v("Save &\n                Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseProceed
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopAddTracking",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddTracking
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97317488","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airImport/airImportTracking.vue
// module id = 2804
// module chunks = 0